module.exports = __webpack_public_path__ + "static/media/confirmation-printer.eb3b2f88.svg";